import type { Integration } from '../../../types/api';
import { FormField, FormLabel, FormInput } from '../../ui';

interface DigisacTabProps {
  integration: Integration | null;
}

function DigisacTab({ integration }: DigisacTabProps) {
  return (
    <div className="space-y-6">
      <FormField>
        <FormLabel htmlFor="digisac_account">Conta Digisac</FormLabel>
        <FormInput
          id="digisac_account"
          name="digisac_account"
          defaultValue={integration?.digisac_account}
        />
      </FormField>

      <div className="grid grid-cols-2 gap-4">
        <FormField>
          <FormLabel htmlFor="digisac_url">URL Digisac</FormLabel>
          <FormInput id="digisac_url" name="digisac_url" defaultValue={integration?.digisac_url} />
        </FormField>

        <FormField>
          <FormLabel htmlFor="digisac_token">Token Digisac</FormLabel>
          <FormInput
            id="digisac_token"
            name="digisac_token"
            defaultValue={integration?.digisac_token}
          />
        </FormField>
      </div>
    </div>
  );
}

export default DigisacTab;
